import Card from 'components/Layout/Card';
import Loader from 'components/Layout/Loader';
import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getMembersAnalyticsData } from 'store/slices';
import { objectToFormData } from 'utils/helpers';
import CalendarFilterDropdown from 'components/Layout/CalendarFilterDropdown/CalendarFilterDropdown';

const MembersAnalyticsPieChart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [chartData, setChartData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [title, setTitle] = useState('');
  const [searchObject, setSearchObject] = useState({});
  const [timer, setTimer] = useState(null);

  const fetchMembersAnalytics = async (searchData) => {
    setIsLoading(true);
    const updatedSearchData = {
      ...Object.fromEntries(
        Object.entries(searchData).map(([key, value]) =>
          key === 'join_date' ? ['date_filter', value] : [key, value]
        )
      ),
      type: 'membership',
    };

    const response = await dispatch(
      getMembersAnalyticsData(objectToFormData(updatedSearchData))
    );

    if (response?.status === 200) {
      setChartData(response?.data || {});
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchMembersAnalytics({ date_filter: 'Last 24 Hours' });
  }, []);

  const searchInputChange = (searchData) => {
    fetchMembersAnalytics(searchData);
  };

  //   const { id, value } = e.target;
  //   setTitle(value);

  //   let newPayload = { ...searchObject, [id]: value };

  //   if (value === 'custom') {
  //     newPayload = {
  //       ...newPayload,
  //       start_date: searchObject.start_date,
  //       end_date: searchObject.end_date,
  //     };
  //   } else if (searchObject.start_date && searchObject.end_date) {
  //     const { start_date, end_date, ...newSearchObject } = searchObject;
  //     newPayload = { ...newSearchObject, [id]: value };
  //   }

  //   setSearchObject(newPayload);

  //   if (timer) clearTimeout(timer);

  //   const newTimer = setTimeout(() => {
  //     searchInputChange(newPayload);
  //   }, 800);

  //   setTimer(newTimer);
  // }

  const handelChangeInput = (e) => {
    let name = e.target.id;
    let value = e.target.value;
    setTitle(e.target.value);
    let newPayload = '';
    if (e.target.value === 'custom') {
      newPayload = {
        ...searchObject,
        [name]: value,
        start_date: e.target.start_date,
        end_date: e.target.end_date,
      };
      setSearchObject(newPayload);
    } else {
      if (searchObject?.start_date && searchObject?.end_date) {
        const { start_date, end_date, ...newSearchObject } = searchObject;
        setSearchObject({ ...newSearchObject, [name]: value });
      } else {
        setSearchObject({ ...searchObject, [name]: value });
      }
    }

    let time = timer;
    clearTimeout(time);
    time = setTimeout(() => {
      if (e.target.value === 'custom') {
        searchInputChange(newPayload);
      } else {
        if (searchObject?.start_date && searchObject?.end_date) {
          const { start_date, end_date, ...newSearchObject } = searchObject;
          searchInputChange({ ...newSearchObject, [name]: value });
        } else {
          searchInputChange({ ...searchObject, [name]: value });
        }
      }
    }, 800);
    setTimer(time);
  };
  const dataList = [
    {
      title: 'Student Members',
      valueKey: 'total_student',
      details: [
        { label: 'Student Free', key: 'student_free_members' },
        { label: 'Student Premium', key: 'student_premium_members' },
      ],
      bgClass: 'bg-2479',
    },
    {
      title: 'Professional Members',
      valueKey: 'total_professional',
      details: [
        { label: 'Professional Free', key: 'professional_free_members' },
        { label: 'Professional Premium', key: 'professional_premium_members' },
        {
          label: 'Professional Lifetime',
          key: 'professional_lifetime_members',
        },
      ],
      bgClass: 'bg-55C7',
    },
    {
      title: 'Institution Members',
      valueKey: 'total_institution',
      details: [
        { label: 'Institution Silver', key: 'institution_silver_members' },
        { label: 'Institution Gold', key: 'institution_gold_members' },
        { label: 'Institution Diamond', key: 'institution_diamond_members' },
      ],
      bgClass: 'bg-8992',
    },
  ];

  return (
    <div className="cmt-20">
      <Card className="cpt-26 cpb-40 cps-53 cpe-53">
        <div className="d-flex justify-content-end cmb-10">
          <CalendarFilterDropdown
            onChange={handelChangeInput}
            elem={{ title: 'Join Date' }}
          />
        </div>

        {isLoading ? (
          <Loader size="sm" />
        ) : (
          <div className="row">
            <div className="col-md-6">
              <div className="text-20-500-25 color-1717 cmb-38">
                IFERP Member’s Analytics
              </div>
              <div>
                {dataList.map((item, index) => (
                  <div key={index}>
                    <div
                      className={`d-flex align-items-center gap-3 ${
                        expandedIndex === index ? 'cmb-5' : 'cmb-20'
                      }`}
                    >
                      <div className={`rounded-color ${item.bgClass}`}></div>
                      <div className="text-16-400-20 color-0000 min-width-250">
                        {item.title}
                      </div>
                      <div className="text-16-400-20 color-0000">
                        : {chartData[item.valueKey] || 0}
                      </div>
                      <div
                        className="color-7cff text-14-400-18 pointer d-flex align-items-center"
                        onClick={() =>
                          setExpandedIndex(
                            expandedIndex === index ? null : index
                          )
                        }
                      >
                        <i
                          className={`bi ${
                            expandedIndex === index
                              ? 'bi-chevron-up'
                              : 'bi-chevron-down'
                          } fs-5 text-black`}
                        ></i>
                      </div>
                    </div>

                    {expandedIndex === index && (
                      <div className="cps-45">
                        {item.details.map((detail, i) => (
                          <div
                            key={i}
                            className="text-14-300-18 color-dark-gray cpt-2 cpb-12"
                          >
                            {detail.label} : {chartData[detail.key] || 0}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div className="d-flex align-items-center gap-3 text-20-500-25 color-1717 cps-38">
                <div className="">Total Users</div>
                <div className="">: {chartData?.total_users || 0}</div>
              </div>
            </div>

            <div className="col-md-6 h-100">
              <div
                className="flex justify-center items-center"
                style={{
                  // height: "500px", // Increase container height
                  width: '100%', // Increase container width
                  overflow: 'visible', // Allow labels to render outside the chart
                }}
              >
                <ReactApexChart
                  options={{
                    labels: [
                      'Student Members',
                      'Professional Members',
                      'Institution Members',
                    ],
                    dataLabels: {
                      enabled: true,
                      formatter: function (val, opts) {
                        // Combine count and percentage
                        const count = opts.w.globals.series[opts.seriesIndex];
                        return `${count}\n(${val.toFixed(1)}%)`; // Count and percentage on separate lines
                      },
                      style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        colors: ['#000000'], // Data label color
                      },
                      dropShadow: {
                        enabled: false, // Disable shadow for cleaner text
                      },
                    },
                    plotOptions: {
                      pie: {
                        customScale: 0.9,
                        dataLabels: {
                          offset: 80, // Move data labels outside the chart slice
                          minAngleToShowLabel: 15, // Ensures labels are displayed for smaller slices
                        },
                        expandOnClick: true,
                        donut: {
                          size: '50%',
                          labels: {
                            show: true,
                            total: {
                              show: true,
                              showAlways: true,
                              label: 'Total',
                              fontSize: '20px',
                              lineHeight: '25px',
                              fontWeight: 500,
                              color: '#171717',
                              offsetY: 20,
                              formatter: function (w) {
                                // Calculate and display the total count
                                return w.globals.seriesTotals.reduce(
                                  (a, b) => a + b,
                                  0
                                );
                              },
                            },
                          },
                        },
                      },
                    },
                    grid: {
                      padding: {
                        top: 10, // Adjust top padding for more plot area
                        bottom: 10, // Adjust bottom padding
                      },
                    },
                    colors: ['#2479E0', '#55C7FA', '#8992E0'],
                    stroke: {
                      width: 0,
                    },
                    legend: { show: false }, // Hide legend
                  }}
                  series={[
                    chartData?.total_student || 0,
                    chartData?.total_professional || 0,
                    chartData?.total_institution || 0,
                  ]}
                  type="donut"
                  height={350}
                />
              </div>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
};

export default MembersAnalyticsPieChart;
